module.exports = __webpack_public_path__ + "static/img/10commitments_2.398759c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/10commitments_2.jpg
// module id = gsvN
// module chunks = 0